import { fitTextOnNLines } from "@remotion/layout-utils";
import { useEffect, useRef, useState } from "react";
import lowerThird from "../../../../assets/images/ai-videos/doviz/lower.png";

const TITLE_HEIGHT = 133;
const TITLE_PADDING = 10;
const TITLE_MAX_LINES = 2;
const titleLineHeightPx = Math.floor((TITLE_HEIGHT - TITLE_PADDING * 2) / TITLE_MAX_LINES);

const CATEGORY_HEIGHT = 133;
const CATEGORY_PADDING = 30;
const CATEGORY_MAX_LINES = 1;
const categoryLineHeightPx = Math.floor((CATEGORY_HEIGHT - CATEGORY_PADDING * 2) / CATEGORY_MAX_LINES);

export default function DovizSlidePreview({ news }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    function updateScale() {
      if (!containerRef.current) return;
      const width = containerRef.current.getBoundingClientRect().width;
      setScale(width / 1920);
    }
    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, []);

  return (
    <div
      ref={containerRef}
      className="w-full relative select-none"
      style={{
        aspectRatio: "16 / 9",
        overflow: "hidden",
        backgroundColor: "rgba(0, 0, 0, 0)",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: 1920,
          height: 1080,
          transform: `scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        {/* Background Image */}
        <img
          src={news.image}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 0,
          }}
        />

        <img
          src={lowerThird}
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        />

        {/* Category */}
        <div
          style={{
            position: "absolute",
            bottom: 109,
            left: 214,
            color: "white",
            fontFamily: "Inter",
            fontWeight: "bold",
            width: 280,
            height: CATEGORY_HEIGHT,
            padding: CATEGORY_PADDING,
            boxSizing: "border-box",
            textAlign: "center",
            zIndex: 2,
            lineHeight: `${categoryLineHeightPx}px`,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: CATEGORY_MAX_LINES,
            WebkitBoxOrient: "vertical",
            fontSize: fitTextOnNLines({
              text: news.category,
              maxBoxWidth: 280 - CATEGORY_PADDING * 2,
              maxLines: CATEGORY_MAX_LINES,
              fontFamily: "Inter",
              fontWeight: "bold",
              maxFontSize: categoryLineHeightPx,
            }).fontSize,
          }}
        >
          {news.category}
        </div>

        {/* Title */}
        <div
          style={{
            position: "absolute",
            color: "black",
            fontFamily: "Inter",
            fontWeight: "normal",
            bottom: 109,
            left: 494,
            zIndex: 2,
            height: TITLE_HEIGHT,
            width: 1280,
            padding: TITLE_PADDING,
            boxSizing: "border-box",
            lineHeight: `${titleLineHeightPx}px`,
            overflow: "hidden",
            display: "-webkit-box",
            WebkitLineClamp: TITLE_MAX_LINES,
            WebkitBoxOrient: "vertical",
            fontSize: fitTextOnNLines({
              text: news.title,
              maxBoxWidth: 1280 - TITLE_PADDING * 2,
              maxLines: TITLE_MAX_LINES,
              fontFamily: "Inter",
              fontWeight: "normal",
              maxFontSize: titleLineHeightPx,
            }).fontSize,
          }}
        >
          {news.title}
        </div>
      </div>
    </div>
  );
}
